import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { OperadorPlanoSaudeModel } from "../model/operador-plano-saude.model";

@Injectable()
export class OperadorPlanoSaudeService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Operador Plano de Saúde por id
     * @param id ID da Operador Plano de Saúde
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "plano-saude/operador/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Operador Plano de Saúde
     * @param id ID da Operador Plano de Saúde
     */
    getAll(params: Record<string, unknown>): Observable<ApiPaginationResponseDataNonNullable<OperadorPlanoSaudeModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<OperadorPlanoSaudeModel>>(
            this.utilitesService.urlPrefix + "plano-saude/operador" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Lista de Operador Plano de Saúde
     * @param id ID da Operador Plano de Saúde
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "plano-saude/operador/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Operador Plano de Saúde
     * @param id ID da Operador Plano de Saúde
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "plano-saude/operador/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Operador Plano de Saúde
     * @param params Json Operador Plano de Saúde
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "plano-saude/operador", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Operador Plano de Saúde
     * @param params Json Operador Plano de Saúde
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(this.utilitesService.urlPrefix + "plano-saude/operador/" + id, JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }
}
